/*
 * Ryan O'Dowd
 * 2025-07-05
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({isDarkMode, globalScale, colors}) => {
  return {
    container: {
      color: isDarkMode ? colors.primaryExtraLight : colors.primaryDark,
      fontSize: globalScale * 17,
      marginTop: globalScale * -16, // @TODO: offset the dialog.title
    },
  };
};

export default getStyles;
